import * as React from "react";
import { Container, Dropdown, Accordion, Card, Button ,Form,Spinner,} from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { CustomerService } from "../../Common/Services/CustomerService";
import  CustomerMasterSlidout  from "../../Modules/Masters/CustomerMasterSlidout";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
const { SearchBar } = Search;
import paginationFactory from 'react-bootstrap-table2-paginator';
import { COAMasterSlidout } from "./COAMasterSlideout";
import _ from "lodash";
import { TransactionService } from "../../Common/Services/TransactionService";


  
export class COAMaster extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
         
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          coainfo:{},
          selectedcolumn: "All",
          selectOptions: [
            { id: 'All', name: 'All'},
            { id: 'COA', name: 'COA' },
            { id: 'Name', name: 'Name' },
            { id: 'Account Type', name: 'Account Type' },
            { id: 'Main Group', name: 'Main Group' },
            { id: 'Sub Group', name: 'Sub Group' },
          ],
          data:[]
        };
        
     
      }
      
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getCOAMaster(requestlist);
      }

      handleSelectedItem1 = (control: any, id: any) => {
        let searcResult1 = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult))
        );
    
        let chkisstatus = id == "Status" ? true : false;
        let chkisAccountType = id == "Account Type" ? true : false;
        let chkismaingroup = id == "Main Group" ? true : false;
        let chkisname = id == "Name" ? true : false;
        let chkissubgroup = id == "Sub Group" ? true : false;
        let chkcoa = id == "COA" ? true : false;
    
        if (id == "All") {
          chkisstatus = true;
          chkisAccountType = true;
          chkismaingroup = true;
          chkisname = true;
          chkissubgroup = true;
          chkcoa = true;
        }
    
    
        this.setState({
          searcResult: [], selectedcolumn: id, isstatus: chkisstatus, isaccountType : chkisAccountType, ismainGroup: chkismaingroup,
          isname: chkisname, issubGroup: chkissubgroup, iscoa:chkcoa
        },
          () => {
            this.setState({ searcResult: searcResult1 });    
          }
    
    
        );
    
      };
 
      getCOAMaster = (requestlist: any) => {
 //let requestlist = { ...this.state.requestlist };
    let coaListItems: any = [];

    TransactionService.GetCOA(requestlist)
      .then(async (result: any | null) => {
        if (result != null) {
         
          this.setState({ data: result });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
      };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({ showSlideout: true ,coainfo:row,isSpinner:false});  
    },
  };
  
  showNewSlideOut = () => {
    this.setState({ showSlideout: true ,coainfo:{},isSpinner:false});  
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false, isSpinner:false, });
    let requestlist = { ...this.state.requestlist };
    this.getCOAMaster(requestlist);
};


  render() {
    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {

      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: '10', value: 10
      },
      {
        text: '25', value: 25
      },
      {
        text: '50', value: 50
      },

      {
        text: 'All', value: this.state.searcResult.length
      }] // A numeric array is also available. the purpose of above example is custom the text
    };
    const {
      
      showSlideout,
      
  } = this.state;

  const columns = [
    {
      searchable: this.state.iscoa,
      dataField: 'accountCode',
      text: 'COA',
      sort: true,
    },
   
    {
      searchable: this.state.isname,
      dataField: 'accountName',
      text: 'Name',
      sort: true,
    },
    {
      searchable: this.state.isaccountType,
      dataField: 'accountType',
      text: 'Account Type',
    },
    {
      searchable: this.state.ismainGroup,
      dataField: 'mainGroup',
      text: 'Main Group',
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'subgroupname',
      text: 'Sub Group 1',
      formatter: (cell, row) => {
        return row.subgroupname ?  row.subgroupname:'None' ;
      }
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'subgroup2name',
      text: 'Sub Group 2',
      formatter: (cell, row) => {
        return row.subgroup2name ? row.subgroup2name:'None' ;
      }
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'subgroup3name',
      text: 'Sub Group 3',
      formatter: (cell, row) => {
        return row.subgroup3name ?row.subgroup3name: 'None';
      }
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'rowtitlename',
      text: 'Row title',
      formatter: (cell, row) => {
        return row.rowtitlename ?row.rowtitlename: '(Match COA Name)';
      }
    },  

    {
      dataField: 'isActive',
      text: 'Status',
      sort: true,
      headerStyle: { width: '200px' },
      headerClasses: 'text-center',
      classes: 'text-center',
      
      searchable: this.state.isstatus,
      //searchable:this.state.isdueDate,
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
          <>
         
          <EllipsisWithTooltip placement="bottom">
            
              

                <span className={ row.isActive===true ? "badge badge-pill badge-primary color-green" : "badge badge-pill badge-primary color-red"}> {row.isActive==true? "Active":"Inactive"} </span>


            </EllipsisWithTooltip>
      
      
            </>

        );
    },
    },
  ];
    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">

            Chart of Accounts
              <div className="action-group d-flex flex-row ml-auto">
                <Button onClick={this.showNewSlideOut}>Add COA</Button>
              </div>
            </div>

            <section className="mt-3">
            <ToolkitProvider
        keyField="id"
        data={this.state.data}
        columns={columns}

        search
      >
        {
          props => (


            <div >
              <section className="d-flex flex-wrap gap-3 pb-2">
                <div className="position-relative">
                  <SearchBar {...props.searchProps} />
                </div>

                <div className="col-12 col-md-2">
                    <SingleDropdownListWithoutSearch
                      
                      itemList={this.state.selectOptions}
                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                      defaultItem={this.state.selectedcolumn}
                      defaultText={"Select Filter"}
                      defaultName={this.state.selectedcolumn}
                      controlID="1"
                      id={"ddlselected"}

                    />
                </div>

              </section>
              <section className="pb-3">
                <div className="table-responsive divbottom"  >
                  <div className="ml-auto transactions-list payroll-tbl1">
                  <BootstrapTable
                    {...props.baseProps}
                    rowEvents={this.rowEvents}
                    keyField="rowId"
                    wrapperClasses="table-responsive fixed-header-table1"
                  //  pagination={paginationFactorry(options)}

                  />
                  </div>
                </div>
            

              </section>
            </div>

          )
        }
</ToolkitProvider>

          </section>

{(showSlideout &&

<COAMasterSlidout
closeSlideOut={this.closeSlideOut}
coainfo={this.state.coainfo}
id={this.state.id}
>
</COAMasterSlidout>)}
          </Container>
       </React.Fragment>
      </>
    );
  }
}